export default __webpack_public_path__ + "assembly1134793a.png";